export default "__VITE_ASSET__096ea660__"